import { Pagination, Spin } from "antd";
import { useContext, useEffect } from "react";
import List from "./List";
import mainContext from "../context/MainContext/mainContext";
import { FaInbox } from "react-icons/fa";

const SOPendingContent = () => {
  const {
    searchQuery,
    pageSize,
    pageNumber,
    setPageNumber,
    setPageSize,
    fetchSalesOrders,
    salesOrders,
    fetchToggle,
    totalOrders,
    searchToggle,
    loading,
    preservePageNumberOnNextListMount,
    setPreservePageNumberOnNextListMount,
    financialYear,
  } = useContext(mainContext);

  const handlePageChange = (page, size) => {
    setPageNumber(page);
    setPageSize(size);
  };

  useEffect(() => {
    if (preservePageNumberOnNextListMount) {
      setPreservePageNumberOnNextListMount(false);
    } else {
      setPageNumber(1);
    }
  }, []);

  useEffect(() => {
    fetchSalesOrders("pending");
  }, [pageNumber, pageSize, fetchToggle, financialYear]);

  const filteredOrders = salesOrders?.filter(
    (order) => order.SOConfirmed === false
  );

  useEffect(() => {
    // If deletion makes current page invalid (e.g., last item on last page removed),
    // clamp to the last valid page so we don't show a blank list.
    const totalOrdersCount = totalOrders || { pending: 0, confirmed: 0 };
    const totalCount = searchToggle
      ? filteredOrders?.length || 0
      : totalOrdersCount.pending || 0;

    const totalPages = Math.ceil((totalCount || 0) / (pageSize || 1));
    const safeTotalPages = totalPages > 0 ? totalPages : 1;

    if (pageNumber > safeTotalPages) {
      setPageNumber(safeTotalPages);
    }
  }, [
    totalOrders,
    searchToggle,
    filteredOrders?.length,
    pageSize,
    pageNumber,
    setPageNumber,
  ]);

  const getTotalCount = () => {
    let totalOrdersCount = totalOrders || { pending: 0, confirmed: 0 };

    let total;

    if (searchToggle) {
      total = filteredOrders.length; // When search is applied, show filtered count
    } else {
      total = totalOrdersCount.pending;
    }

    console.log(`Total Count: ${total}`);
    return total;
  };

  return (
    <div className="salesOrder-tab-list">
      <div className="salesOrder-list-container">
        {loading ? ( // Show spinner when loading
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100px",
            }}
          >
            <Spin size="large" /> {/* Ant Design Spinner */}
          </div>
        ) : filteredOrders && filteredOrders.length > 0 ? (
          filteredOrders.map((order) => <List key={order._id} order={order} type="pending"/>)
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "gray",
              marginBottom: "1rem",
            }}
          >
            <FaInbox /> No pending sales orders yet!
          </div>
        )}

        <Pagination
          style={{ margin: "auto" }}
          current={pageNumber}
          pageSize={pageSize}
          total={getTotalCount()}
          onChange={handlePageChange}
          showSizeChanger
          pageSizeOptions={["10", "20", "50"]}
          defaultPageSize={10}
        />
      </div>
    </div>
  );
};
export default SOPendingContent;
